'use client';

import { DirittoAccountPage } from 'app/(main)/accounts/diritto-account/DirittoAccountPage';

export default function Page() {
  return (
    <>
      <title>디리토 계정 | 디리토</title>
      <DirittoAccountPage />
    </>
  );
}
